


























import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
    components: {},
})
export default class CspDialog extends Vue {
    @Prop({
        default: {
            cspDialogVisible: false,
            title: '',
            content: '',
        },
    })
    public config: any;

    public created() {}
    public mounted() {}

    public confirm() {
        this.$emit('cspdiaConfirm');
        this.config.cspDialogVisible = false;
    }
    public close() {
        this.$emit('cspdiaClose');
        this.config.cspDialogVisible = false;
    }
}
